<template>
  <div class="list-container">
    <BusinessList
      :showStateFilter="true"
      :showDefaultCommand="false"
      ref="BusinessListRef"
      v-show="!dialogFormVisible"
      :approvalParams="{
        modify: 2,
        changeStatus: 1
      }"
      :formDisabled="true"
      businessTypeName="TABLE_APPROVAL_CANCEL_BUSINESS"
      :FilterFieldProps="FilterField"
    >
      <template v-slot:command="{ scope }">
        <el-link
          href="javascript:void(0);"
          class="mr-10"
          type="primary"
          @click="handleApproval(scope)"
        >
          审批取消
        </el-link>
      </template>
    </BusinessList>
    <div v-if="dialogFormVisible">
      <div style="display:flex;padding-top:20px">
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="originFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'business'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
      </div>
      <div class="dialog-footer ml-20 mb-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import FormComponent from '@/components/Form/index.vue'
import { FromFieldData } from '@/views/business/businessList/FieldFrom'
import { cloneDeep } from 'lodash'
import { reviewApprove, reviewReject, getDetailById } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'
import { FilterField } from './FilterField'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Appeovalbusinesscancel',
  components: {
    BusinessList,
    FormComponent
  },
  setup() {
    const { t } = useI18n()
    const BusinessListRef = ref(null)
    const dataMap = reactive({
      activeId: 0,
      dialogFormVisible: false,
      submitLoading: false,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      FilterField,
      handleApproval({ row }: any) {
        // 处理接口拿到的数据
        dataMap.activeId = row.id
        dataMap.originFromFieldData = cloneDeep(dataMap.initFormData)
        const cancelComment = {
          title: '申请理由',
          type: 1,
          labelClass: 'yellow',
          labelName: '申',
          formList: [
            {
              componentType: 'el-textarea',
              componentName: '输入框',
              fieldKey: 'cancelComment',
              fieldName: '',
              placeholder: '',
              value: '',
              rules: [{ required: true, message: '', trigger: 'change' }],
              config: {
                isDisabled: false,
                clearable: true,
                url: '',
                filterable: false,
                width: '100%'
              }
            }
          ]
        }
        dataMap.originFromFieldData.push(cancelComment)
        getDetailById('business', row.id).then((res: any) => {
          dataMap.originFromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = res[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: res.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: res.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(res.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt(
              '请输入原因：',
              '提交',
              {
                confirmButtonText: t('table.confirm'),
                cancelButtonText: t('table.cancel'),
                cancelButtonClass: 'el-button--danger'
              }
            ).then(async(params: any) => {
              const { value } = params
              await reviewReject('business', dataMap.activeId, { comment: value })
              ;(BusinessListRef.value as any).getList()
              dataMap.dialogFormVisible = false
              ElMessage.success('操作成功！')
            })
          } else if (type === 'approve') {
            await reviewApprove('business', dataMap.activeId)
            ;(BusinessListRef.value as any).getList()
            dataMap.dialogFormVisible = false
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(222)
        }
      }
    })
    return { t, ...toRefs(dataMap), BusinessListRef }
  }
})
</script>
